<div class="cardLayout" *ngIf="operation === 'fixedBudget'">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-18 font_bold cl-black">Emp. given fixed budget VP</p>
        </div>
        <div class="popup-close">
          <button class="download-btn" (click)="downloadExcelForInputfixedBudget()">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>

    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <div class="table-container">
        <table class="Market-correction-employees-table">
          <thead>
            <tr>
              <th *ngIf="showFixedBudgetDept" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Department
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetDept')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetBand" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Band
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetBand')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetEmployee" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Employee
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetEmployee')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetManager" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Manager
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetManager')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetHod" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  HOD
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetHod')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetDesignation" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Designation
                  <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetDesignation')">visibility_off</span>
                </div>
              </th>
              <th *ngIf="showFixedBudgetDoj" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  DOJ
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetDoj')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetPA" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Total Fixed CTC p.a
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetPA')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetPM" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Total Fixed CTC p.f.
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetPM')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetEmpVariableBonus" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Variable bonus category %age of CTC OR fixed budget
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetVariableBonus')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetEmpProratedVB" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Prorated VB %age / Amount
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetProratedVB')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showFixedBudgetEmpFinalVB" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Final VB Amount
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleFixedBudget('fixedBudgetFinalVB')">visibility_off</span> -->
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let dept of departmentGroups">
              <ng-container *ngFor="let bandGroup of dept.bands; let i = index">
                <ng-container *ngFor="let emp of bandGroup.employees; let j = index">
                  <tr>
                    <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(dept.bands)" class="center-vertical">
                      {{ dept.departmentName }}</td>
                    <td *ngIf="j === 0" [attr.rowspan]="bandGroup.employees.length" class="center-vertical">{{
                      bandGroup.bandName }}</td>
                    <td>{{ emp.employeeName }}</td>
                    <td>{{ emp.managerName }}</td>
                    <td>{{ emp.hodName }}</td>
                    <td>{{ emp.designation }}</td>
                    <td>{{ emp.employeeDOJ | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ emp.totalFixedCTCpa }}</td>
                    <td>{{ emp.totalFixedCTCpm }}</td>
                    <td>{{ emp.vpBonusCategoryOfCTC_OR_FixedBudget}}</td>
                    <td>{{ emp.proratedVPPercentAmount}}</td>
                    <td>{{ emp.finalVPAmount}}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</div>

<div class="cardLayout" *ngIf="operation === 'empCTC'">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-18 font_bold cl-black">Emp. given % of CTC</p>
        </div>
        <div class="popup-close">
          <button class="download-btn" (click)="downloadExcelForInputfixedBudget()">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>

    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <div class="table-container">
        <table class="Market-correction-employees-table">
          <thead>
            <tr>
              <th *ngIf="showEmpCTCDept" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Department
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCDept')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCBand" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Band
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCBand')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCEmployee" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Employee
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCEmployee')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCManager" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Manager
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCManager')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCHod" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  HOD
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCHod')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCDesignation" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Designation
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCDesignation')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCDoj" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  DOJ
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCDoj')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCPA" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Total Fixed CTC p.a
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCPA')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpCTCPM" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Total Fixed CTC p.f.
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empCTCPA')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpVariableBonus" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Variable bonus category %age of CTC OR fixed budget
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empVariableBonus')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpProratedVB" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Prorated VB %age / Amount
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empProratedVB')">visibility_off</span> -->
                </div>
              </th>
              <th *ngIf="showEmpFinalVB" class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Final VB Amount
                  <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                    (click)="toggleEmpCTC('empFinalVB')">visibility_off</span> -->
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let dept of departmentGroups">
              <ng-container *ngFor="let bandGroup of dept.bands; let i = index">
                <ng-container *ngFor="let emp of bandGroup.employees; let j = index">
                  <tr>
                    <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(dept.bands)" class="center-vertical">
                      {{ dept.departmentName }}</td>
                    <td *ngIf="j === 0" [attr.rowspan]="bandGroup.employees.length" class="center-vertical">{{
                      bandGroup.bandName }}</td>
                    <td>{{ emp.employeeName }}</td>
                    <td>{{ emp.managerName }}</td>
                    <td>{{ emp.hodName }}</td>
                    <td>{{ emp.designation }}</td>
                    <td>{{ emp.employeeDOJ | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ emp.totalFixedCTCpa }}</td>
                    <td>{{ emp.totalFixedCTCpm }}</td>
                    <td>{{ emp.vpBonusCategoryOfCTC_OR_FixedBudget}}</td>
                    <td>{{ emp.proratedVPPercentAmount}}</td>
                    <td>{{ emp.finalVPAmount}}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</div>

<div class="cardLayout" *ngIf="operation === 'eligibleEmployees'">
  <!-- <div class="cardLayout"> -->
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-18 font_bold cl-black">Eligible employees ({{totalEmp}})</p>
          </div>
          <div class="popup-close">
            <div class="mr-30">
              <label class="mr-10">Female</label>
              <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
              <label class="mr-10">Male</label>
            </div>
            <button class="download-btn" (click)="downloadExcelForInputeligibleEmployees()">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              Download
            </button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>

      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table class="Market-correction-employees-table">
            <thead>
              <tr>
                <th *ngIf="showDepartment" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Department
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('department')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showaBandandGrade" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Band
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('bandandgrade')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showEmployee" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Employee
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('employee')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showManager" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Manager
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('manager')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showHOD" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    HOD
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('HOD')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showDOJ" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    DOJ
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('DOJ')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showEligibleEmployee" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Eligible Emp
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('eligibleEmployee')">visibility_off</span> -->
                  </div>
                </th>
                <th *ngIf="showDaysServedInVariablePayPeriod" class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Days served in the VP period
                    <!-- <span class="material-icons cp ml-20 mt-3 fs-14"
                      (click)="toggleEligibleEmployee('daysServedVP')">visibility_off</span> -->
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let dept of departmentGroups">
                <ng-container *ngFor="let bandGroup of dept.bands; let i = index">
                  <ng-container *ngFor="let emp of bandGroup.employees; let j = index">
                    <tr>
                      <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(dept.bands)" class="center-vertical">
                        {{ dept.departmentName }}</td>
                      <td *ngIf="j === 0" [attr.rowspan]="bandGroup.employees.length" class="center-vertical">{{
                        bandGroup.bandName }}</td>
                      <td>{{ emp.employeeName }}</td>
                      <td>{{ emp.managerName }}</td>
                      <td>{{ emp.hodName }}</td>
                      <td>{{ emp.employeeDOJ | date: 'dd/MM/yyyy' }}</td>
                      <td>{{ emp.isEligible?'Yes':'No' }}
                      <td>{{ emp.daysServed }}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  <!-- </div> -->
</div>